import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ExcelModule, GridModule } from '@progress/kendo-angular-grid';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { SalesWebOrdersModule } from '@tt-chvac/order';
import { SalesWebWorkpackageModule } from '@tt-chvac/work-package';
import { RefreshService } from '@tt-chvac/core';
import { SharedCoreSaleswebModule } from '@tt-chvac/core-sales-web';
import { RedirectJobsListComponent } from '../../redirect-jobs-list/redirect-jobs-list.component';
import { SharedModule } from '../../shared/modules/shared/shared.module';
import { UserInfoResolver } from '../../user-info-resolver.service';
import { HomeDashboardComponent } from './home-dashboard/home-dashboard.component';
import { HomePageListRoutingModule } from './home-page-list/home-page-list-routing.module';
import { HomePageListComponent } from './home-page-list/home-page-list.component';

@NgModule({
  declarations: [HomePageListComponent, RedirectJobsListComponent, HomeDashboardComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    DropDownsModule,
    ExcelModule,
    GridModule,
    TooltipModule,
    InputsModule,
    HomePageListRoutingModule,
    LayoutModule,
    SharedModule,
    SalesWebOrdersModule,
    SalesWebWorkpackageModule,
    SharedCoreSaleswebModule,
  ],
  providers: [UserInfoResolver, RefreshService],
})
export class HomePageModule { }
